import { useOverlays } from "contexts/OverlayContext";
import { NativeInvoiceDrawer } from "./NativeInvoiceDrawer";

function getNativeInvoiceDrawerSessionKey(overlayInfo: {
    instanceId: number;
    data?: {
        invoiceId?: string;
        editTemplate?: { templateId: string };
        applyTemplate?: { templateId: string };
        createTemplate?: boolean;
        duplicateTemplate?: { templateId: string };
    };
}): string {
    if (overlayInfo.data?.createTemplate && overlayInfo.data?.invoiceId) {
        return `create-template-from-invoice-${overlayInfo.data.invoiceId}-${overlayInfo.instanceId}`;
    }
    if (overlayInfo.data?.invoiceId) {
        return overlayInfo.data.invoiceId;
    }
    if (overlayInfo.data?.createTemplate) {
        return `create-template-${overlayInfo.instanceId}`;
    }
    if (overlayInfo.data?.duplicateTemplate) {
        return `duplicate-template-${overlayInfo.data.duplicateTemplate.templateId}-${overlayInfo.instanceId}`;
    }
    if (overlayInfo.data?.editTemplate) {
        return `template-${overlayInfo.data.editTemplate.templateId}`;
    }
    if (overlayInfo.data?.applyTemplate) {
        return `apply-${overlayInfo.data.applyTemplate.templateId}-${overlayInfo.instanceId}`;
    }
    return `new-${overlayInfo.instanceId}`;
}

export const NativeInvoiceDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("nativeInvoiceDrawer");

    if (!overlayInfo) {
        return null;
    }

    // Key remounts when switching invoice ids (or create ↔ edit) without relying
    // on effects to reset form session state. instanceId also bumps the key so
    // reopening a fresh create-with-prefill session (invoiceId stays undefined)
    // remounts instead of reusing the previous create session's form state.
    const sessionKey = getNativeInvoiceDrawerSessionKey(overlayInfo);

    return (
        <NativeInvoiceDrawer
            key={sessionKey}
            open={!overlayIsClosing}
            onClose={closeOverlay}
            initialInvoiceId={overlayInfo.data?.invoiceId}
            createPrefill={overlayInfo.data?.createPrefill}
            applyTemplate={overlayInfo.data?.applyTemplate}
            editTemplate={overlayInfo.data?.editTemplate}
            createTemplate={overlayInfo.data?.createTemplate}
            duplicateTemplate={overlayInfo.data?.duplicateTemplate}
        />
    );
};
